module.exports = __webpack_public_path__ + "static/5-68d977f663d91f7582751e83fe568bca.jpg";